(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2431],{

/***/ 62431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ProductGallery; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _productGallery_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83135);
/* harmony import */ var _productGallery_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_productGallery_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71911);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30719);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84601);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_free_mode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87709);
/* harmony import */ var swiper_css_free_mode__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_free_mode__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_css_thumbs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16172);
/* harmony import */ var swiper_css_thumbs__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css_thumbs__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20835);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_8__);










function ProductGallery(param) {
    let { data , selectedStock  } = param;
    const allGalleries = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        var ref;
        const allStockImages = (data === null || data === void 0 ? void 0 : (ref = data.stocks) === null || ref === void 0 ? void 0 : ref.flatMap((stock)=>{
            return (stock === null || stock === void 0 ? void 0 : stock.galleries) || [];
        })) || [];
        return [
            ...(data === null || data === void 0 ? void 0 : data.galleries) || [],
            ...allStockImages
        ];
    }, [
        data
    ]);
    const currentImageIndex = allGalleries === null || allGalleries === void 0 ? void 0 : allGalleries.findIndex((gallery)=>{
        return (gallery === null || gallery === void 0 ? void 0 : gallery.loadable_id) === (selectedStock === null || selectedStock === void 0 ? void 0 : selectedStock.id);
    });
    const [activeIndex, setActiveIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(currentImageIndex === -1 ? 0 : currentImageIndex);
    const [thumbsSwiper, setThumbsSwiper] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const mainSwiperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const handleSlideChange = ()=>{
        var ref, ref1;
        setActiveIndex((ref = mainSwiperRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.swiper) === null || ref1 === void 0 ? void 0 : ref1.realIndex);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (currentImageIndex && currentImageIndex >= 0) {
            var ref;
            (ref = mainSwiperRef.current) === null || ref === void 0 ? void 0 : ref.swiper.slideTo(currentImageIndex);
            thumbsSwiper === null || thumbsSwiper === void 0 ? void 0 : thumbsSwiper.slideTo(currentImageIndex);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentImageIndex
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_productGallery_module_scss__WEBPACK_IMPORTED_MODULE_9___default().container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_productGallery_module_scss__WEBPACK_IMPORTED_MODULE_9___default().thumbsContainer),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .Swiper */ .tq, {
                    onSwiper: setThumbsSwiper,
                    spaceBetween: 10,
                    slidesPerView: "auto",
                    freeMode: true,
                    watchSlidesProgress: true,
                    modules: [
                        swiper__WEBPACK_IMPORTED_MODULE_2__/* .FreeMode */ .Rv,
                        swiper__WEBPACK_IMPORTED_MODULE_2__/* .Navigation */ .W_,
                        swiper__WEBPACK_IMPORTED_MODULE_2__/* .Thumbs */ .o3
                    ],
                    breakpoints: {
                        1024: {
                            direction: "vertical"
                        },
                        0: {
                            direction: "horizontal"
                        }
                    },
                    className: (_productGallery_module_scss__WEBPACK_IMPORTED_MODULE_9___default().thumbsSwiper),
                    children: allGalleries.map((gallery, index)=>{
                        var ref;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .SwiperSlide */ .o5, {
                            className: (_productGallery_module_scss__WEBPACK_IMPORTED_MODULE_9___default().thumbSlide),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat((_productGallery_module_scss__WEBPACK_IMPORTED_MODULE_9___default().thumbImageContainer), " ").concat(index === activeIndex ? (_productGallery_module_scss__WEBPACK_IMPORTED_MODULE_9___default().active) : ""),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                                    src: (gallery === null || gallery === void 0 ? void 0 : gallery.path) || "",
                                    alt: (data === null || data === void 0 ? void 0 : (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title) || "image",
                                    height: 72,
                                    width: 72
                                })
                            })
                        }, gallery === null || gallery === void 0 ? void 0 : gallery.id);
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_productGallery_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mainContainer),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .Swiper */ .tq, {
                    ref: mainSwiperRef,
                    spaceBetween: 27,
                    modules: [
                        swiper__WEBPACK_IMPORTED_MODULE_2__/* .FreeMode */ .Rv,
                        swiper__WEBPACK_IMPORTED_MODULE_2__/* .Navigation */ .W_,
                        swiper__WEBPACK_IMPORTED_MODULE_2__/* .Thumbs */ .o3
                    ],
                    thumbs: {
                        swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null
                    },
                    className: (_productGallery_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mainSwiper),
                    slidesPerView: 1,
                    onSlideChange: handleSlideChange,
                    children: allGalleries.map((gallery)=>{
                        var ref;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .SwiperSlide */ .o5, {
                            className: (_productGallery_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mainSlide),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_productGallery_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mainImageContainer),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                                    src: (gallery === null || gallery === void 0 ? void 0 : gallery.path) || "",
                                    alt: (data === null || data === void 0 ? void 0 : (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title) || "image",
                                    fill: true
                                })
                            })
                        }, gallery === null || gallery === void 0 ? void 0 : gallery.id);
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 83135:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"productGallery_container__IxKs9","mainContainer":"productGallery_mainContainer__fP2M1","mainSwiper":"productGallery_mainSwiper__DzSeI","mainSlide":"productGallery_mainSlide__CwZJt","mainImageContainer":"productGallery_mainImageContainer__wJk93","thumbsContainer":"productGallery_thumbsContainer__wqMe5","thumbsSwiper":"productGallery_thumbsSwiper__BX9m8","thumbSlide":"productGallery_thumbSlide__fdDhW","thumbImageContainer":"productGallery_thumbImageContainer__jlGwG","active":"productGallery_active__Pvv64"};

/***/ }),

/***/ 87709:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 16172:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);